import { mkLockParser } from '@ergolabs/ergo-dex-sdk';

export const lockParser = mkLockParser();
